export { JF_HTTPS_PORT, JF_HTTP_PORT, getAddressCandidates } from './address-candidates.js';
export { getAuthorizationHeader } from './authentication.js';
export { getBrowserDeviceProfile } from './browser-profiles.js';
export { copyUrl, getDefaultPort, hasProtocolAndPort, isDefaultPort, parseUrl } from './url/index.js';
export { isVersionLess } from './versioning.js';
export { HTTPS_PORT, HTTPS_PROTOCOL, HTTP_PORT, HTTP_PROTOCOL } from './url/constants.js';

/**
 * This Source Code Form is subject to the terms of the Mozilla Public
 * License, v. 2.0. If a copy of the MPL was not distributed with this
 * file, You can obtain one at http://mozilla.org/MPL/2.0/.
 */
